import React from "react";
import { Input } from "semantic-ui-react";
import { type ShowDates } from "./models";
import { blurAndSubmitOnEnter } from "utilities/reactUtils";

interface Props {
  placeholder?: string
  showDates: ShowDates
  onTimeOfPerformanceChanged: (newTimeOfPerformance: string) => void
}

const TimeOfPerformance = (props: Props) => {
  if (props.showDates.mode === "allDay") {
    return <EditableTimeOfPerformance {...props} />;
  } else {
    return <ReadonlyTimeOfPerformance value={props.showDates.timeOfPerformance} />;
  }
};

const ReadonlyTimeOfPerformance = ({ value }: { value: string }) => {
  return <Input value={value} fluid disabled />;
};

const EditableTimeOfPerformance = (props: Props) => {
  const [timeOfPerformance, setTimeOfPerformance] = React.useState(props.showDates.timeOfPerformance ?? "");

  return <Input
    placeholder={props.placeholder}
    value={timeOfPerformance}
    maxLength={serverReference.constants.show.maxTimeOfPerformanceLength}
    onChange={(_, data) => { setTimeOfPerformance(data.value); }}
    onBlur={() => { props.onTimeOfPerformanceChanged(timeOfPerformance); }}
    onKeyDown={blurAndSubmitOnEnter}
    fluid
  />;
};

export default TimeOfPerformance;